import CalendarIcon from '@mui/icons-material/CalendarMonth';
import { FuneralCreate } from './FuneralCreate';
import { FuneralEdit } from './FuneralEdit';
import FuneralShow from './FuneralShow';
import { FuneralsList } from './FuneralsList';

const funerals = {
  list: FuneralsList,
  create: FuneralCreate,
  edit: FuneralEdit,
  show: FuneralShow,
  icon: CalendarIcon,
};

export default funerals;
